// component
import MyAssetsList from './list/index.vue';
import MyAssetsAdd from './add/index.vue';
import MyAssetsDetail from './detail/index.vue';

export default [
  {
    path: 'list',
    name: 'MyAssetsList',
    component: MyAssetsList,
    meta: {
      title: '我的资产列表',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'add',
    name: 'MyAssetsAdd',
    component: MyAssetsAdd,
    meta: {
      title: '添加资产信息',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'MyAssetsDetail',
    component: MyAssetsDetail,
    meta: {
      title: '资产信息详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];
